import i18next from 'i18next';

// Helpers do Painel de Curriculo (CULTURE_EMPREGARE e $ sao globais do LayoutAntigo).

export const _URL_FORM = '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/';

export function CURRICULO_PRIVACIDADE() {
    return document.getElementById('CurriculoPrivacidade').value;
}

export function btnAcoesItensCurriculo(id) {
    return '<span class="pull-right"><button type="button" data-id="' + id + '" class="btn btn-xs btn-danger noborder outline btn-excluir mr5"><i class="fa fa-times"></i> ' + i18next.t('btnRemover') + '</button> <button type="button" class="btn btn-xs btn-primary noborder outline btn-editar" data-id="' + id + '"><i class="fa fa-edit"></i> ' + i18next.t('btnEditar') + '</button></span>';
}

export function CURRICULO_TIPO() {
    return 3;
}

export function CURRICULO_COLABORADOR() {
    return (document.getElementById('CurriculoColaborador').value == 'true');
}

export const formatarSalario = function (numberStr, currency) {
    let parts = numberStr.toString().split(/[,\.]/);
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? parts[1] : '00';

    // Adiciona zeros à direita se a parte decimal tiver menos de dois dígitos
    decimalPart = decimalPart.length === 1 ? decimalPart + '0' : decimalPart;

    // Inverte a string para facilitar a adição de pontos/virgulas a cada 3 dígitos
    let reversedIntegerPart = integerPart.split('').reverse().join('');
    let formattedIntegerPart = '';

    for (let i = 0; i < reversedIntegerPart.length; i++) {
        if (i > 0 && i % 3 === 0) {
            formattedIntegerPart += (currency === 'R$') ? '.' : ',';
        }
        formattedIntegerPart += reversedIntegerPart[i];
    }

    // Reverte de volta para o formato original
    formattedIntegerPart = formattedIntegerPart.split('').reverse().join('');

    let formattedNumber = formattedIntegerPart + (currency === 'R$' ? ',' : '.') + decimalPart;

    formattedNumber = currency + ' ' + formattedNumber;

    return formattedNumber;
}

export const visibleY = function (el) {
    var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height,
        el = el.parentNode;
    do {
        rect = el.getBoundingClientRect();
        if (top <= rect.bottom === false) return false;
        // Check if the element is out of view due to a container scrolling
        if ((top + height) <= rect.top) return false;
        el = el.parentNode;
    } while (el != document.body);
    // Check its within the document viewport
    return top <= document.documentElement.clientHeight;
};

export function attachEvent(element, event, callbackFunction) {
    if (element.addEventListener) {
        element.addEventListener(event, callbackFunction, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + event, callbackFunction);
    }
}

export function fecharFormCadastro() {
    // if ($('#isMobile').is(':visible')) {
    $('body').removeClass('modal-open');
    if ($('#launcher').length > 0) {
        $('#launcher').show();
    }
    // }

    window.onbeforeunload = null;
}

export function abrirFormCadastro() {
    if ($('#isMobile').is(':visible')) {
        setTimeout(() => {
            $('body').addClass('modal-open');
        }, 1000);
        if ($('#launcher').length > 0) {
            $('#launcher').hide();
        }
    }

    window.onbeforeunload = function () {
        return i18next.t('abrirFormCadastroOnbeforeunload');
    };
}
